// src/services/aaveService.js

/**
 * Fetch Aave reserves from the appropriate subgraph (mainnet or base)
 * @param {string} apiKey - The Graph API key (REACT_APP_THEGRAPH_API_KEY)
 * @param {string} network - "mainnet" or "base"
 * @returns {Array} Array of reserves: [{id, name, symbol, variableBorrowRate}, ...]
 */
export async function fetchAaveReserves(apiKey, network = "mainnet") {
  // 1) Choose subgraph ID
  //    Example subgraph IDs (adjust as needed):
  //    - Mainnet Aave v2 or v3 subgraph
  //    - Base Aave subgraph from your example
  let subgraphId = "";
  if (network === "mainnet") {
    // Replace this with your actual Aave mainnet subgraph ID
    // For example: "Qm…"
    subgraphId = "Cd2gEDVeqnjBn1hSeqFMitw8Q1iiyV9FYUZkLNRcL87g";
  } else if (network === "base") {
    // From your example usage:
    subgraphId = "GQFbb95cE6d8mV989mL5figjaGaKCQB3xqYrr1bRyXqF";
  } else {
    throw new Error(`Unsupported network: ${network}`);
  }

  // 2) GraphQL query for Aave reserves
  const query = `
    {
      reserves {
        id
        name
        symbol
        variableBorrowRate
      }
    }
  `;

  // 3) Build the Graph endpoint
  const graphUrl = `https://gateway.thegraph.com/api/${apiKey}/subgraphs/id/${subgraphId}`;

  // 4) POST request with the query
  const resp = await fetch(graphUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query }),
  });

  if (!resp.ok) {
    throw new Error(`Aave fetch error: ${resp.status} ${resp.statusText}`);
  }

  const data = await resp.json();
  if (data.errors) {
    throw new Error(`Aave fetch error: ${JSON.stringify(data.errors)}`);
  }

  // 5) Return the "reserves" array
  return data.data?.reserves || [];
}
